import { createFileRoute } from '@tanstack/react-router';

import { exigirAcceso, filtrosUsuariosSchema } from '@/entities/usuario';
import { UsuariosListPage } from '@/pages/usuarios-list';

export const Route = createFileRoute('/_private/usuarios/')({
  validateSearch: filtrosUsuariosSchema,
  // Solo por permiso (ADR-038): sin `usuarios:listar` redirige a la ruta de
  // inicio antes de montar; un permiso delegado abre el módulo.
  beforeLoad: () => exigirAcceso('usuarios'),
  component: UsuariosListPage,
});
